export const OPEN_REVIEWS = 'open reviews';
export const REVIEWS_DOWNLOADED = 'reviews downloaded';
export const POST_REVIEW = 'post review';
export const REVIEW_POSTED = 'review posted';
export const POST_REVIEW_ERROR = 'post review error';
export const TOGGLE_THUMBUP = 'toggle thumbup';
export const TOGGLE_THUMBDOWN = 'toggle thumbdown';
export const THUMBDOWN_DONE = 'thumbdown done';
export const SELECT_REASON = 'select reason';

import {getReviewsByIdentifier} from '../helpers/api.js';
import {postReview as apiPostReview} from '../modules/apiWrapper.js';
import {getInState} from '../helpers/composeReducer.js';

export function postReview(reviewData){
    return function(dispatch, getState){
        dispatch({
            type : POST_REVIEW,
            reviewData
        });
        const partner = getInState(getState,'options.partner_name','');
        let logger    = getInState(getState,'helpers.logger');

        apiPostReview(reviewData, partner, '', logger).then(function(reviewResult){
            dispatch({
                type : REVIEW_POSTED,
                reviewData : {
                    ...reviewData,
                    ...reviewResult
                }
            });
        }, function(error){
            dispatch({
                type : POST_REVIEW_ERROR,
                error
            });
        });
    };
}

/* istanbul ignore next */
export function toggleThumbup(is_off){
    return {
        type: TOGGLE_THUMBUP,
        is_off : !!is_off
    };
}

/* istanbul ignore next */
export function toggleThumbdown(is_off){
    return {
        type: TOGGLE_THUMBDOWN,
        is_off: !!is_off
    };
}

/* istanbul ignore next */
export function thumbdownDone(is_off) {
    return {
        type: THUMBDOWN_DONE,
        is_off: !!is_off
    }
}

/* istanbul ignore next */
export function selectReason(reason_id) {
    return {
        type: SELECT_REASON,
        reason_id
    }
}


// WEBPACK FOOTER //
// ./src/actions/review.action.js